// GenderDonut.tsx
import { Spin } from "antd";
import { useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Cell, Pie, PieChart, ResponsiveContainer } from "recharts";
import useLoading from "../../../hook/useLoading";
import useToast from "../../../hook/useToast";
import { formatNumber } from "../../../services/mixin";
import { selectorInfoUser } from "../../../store/slices/infoUserSlice";
import { IDataDefaulFilter } from "../ReportCustomer";
import '../Customers.scss'


interface props {
    data: any[]
    dataFilter: IDataDefaulFilter
    showLoading: boolean
}

export const GenderDonut: React.FC<props> = ({ data, dataFilter, showLoading }) => {
    const navigate = useNavigate()
    const total = data.reduce((s, i) => s + i.value, 0);


    return (
        <div className="custom-page-css w-full flex flex-1 flex-col justify-between  items-center gap-6">
            <div className="custom-page-css relative w-240px h-240px">
                {showLoading ?
                    <>
                        <ResponsiveContainer>
                            <PieChart>
                                <Pie
                                    data={data}
                                    dataKey="value"
                                    innerRadius={80}
                                    outerRadius={110}
                                    paddingAngle={0}
                                    cursor="pointer"
                                    onClick={(entry) => navigate(
                                        `/analysis-report/customers-card-list`,
                                        {
                                            state: {
                                                firstPage: '/analysis-report/customers',
                                                dataFilter: dataFilter,
                                                typeGender: entry.type,
                                                title: entry.type === 0 ? 'Khách hàng có giới tính là Nam' : entry.type === 1 ? 'Khách hàng có giới tính là Nữ' : 'Khách hàng có giới tính không xác định'
                                            }
                                        }
                                    )}
                                >
                                    {
                                        data.map((entry, index) => (
                                            <Cell key={index} fill={entry.color} />
                                        ))
                                    }
                                </Pie>
                            </PieChart>
                        </ResponsiveContainer>

                        {/* Center text */}
                        <div className="custom-page-css absolute inset-0 flex flex-col items-center justify-center"
                            style={{
                                inset: 0
                            }}>
                            <div className="custom-page-css text-2xl font-regular text-344054">
                                {formatNumber(total ?? 0)}
                            </div>
                            <div className="custom-page-css  text-sm text-98A2B3 font-regular">Khách hàng</div>
                        </div>
                    </>
                    :
                    <div
                        className='custom-page-css flex flex-col gap-2 items-center justify-center'
                        style={{ width: '100%', height: '100%' }}
                    >
                        <Spin size="default" />
                        <span>Đang tải...</span>
                    </div>
                }
            </div>

            {/* Legend */}
            <div className="space-y-2 pb-2">
                {
                    data.map((item) => {
                        const percent = total ?
                            ((item.value / total) * 100).toFixed(0) :
                            0;
                        return (
                            <div key={item.name} className="custom-page-css flex items-center gap-2 text-sm">
                                <span
                                    className=" custom-page-css w-2 h-2 rounded-full"
                                    style={{ background: item.color }}
                                />
                                <span>
                                    {item.name}: {formatNumber(item.value)} ({percent}%)
                                </span>
                            </div>
                        );
                    })
                }
            </div>
        </div>
    );
};
